import { ActionCreator } from 'redux';
import { DomainDetail, DomainPayload } from '@dev/ee-api/ee-api-models';
import { ApplicationState } from '@/store';
import {
    DomainFetchStartAction,
    DomainFetchSuccessAction,
    DomainFetchErrorAction,
    DomainAddStartAction,
    DomainAddFinishAction,
    DomainAddErrorAction,
    DomainFetchSpecificStartAction,
    DomainVerifySpecificStartAction,
    DomainFetchSpecificSuccessAction,
    DomainDeleteSpecificStartAction,
    DomainDeleteSpecificSuccessAction,
    DomainSetDefaultAction,
    DomainSetDefaultSuccessAction,
    DomainUpdateStartAction,
    DomainUpdateSuccessAction,
    DomainUpdateErrorAction,
    DomainVerifySpecificSuccessAction,
    DomainVerifySpecificErrorAction,
    DomainSetDefaultErrorAction,
    ClearSingleDomainAction,
    ActionTypes,
    DomainState,
    AddDomainErrorMessage,
} from './types';
export const LoadDomains: ActionCreator<DomainFetchStartAction> = (): DomainFetchStartAction => ({
    type: ActionTypes.DOMAIN_FETCH_START,
});
export const LoadDomainsError: ActionCreator<DomainFetchErrorAction> = (): DomainFetchErrorAction => ({
    type: ActionTypes.DOMAIN_FETCH_ERROR,
});
export const LoadDomainsSuccess: ActionCreator<DomainFetchSuccessAction> = (
    domains: DomainDetail[]
): DomainFetchSuccessAction => ({
    type: ActionTypes.DOMAIN_FETCH_SUCCESS,
    payload: {
        domains,
    },
});
export const AddDomainStart: ActionCreator<DomainAddStartAction> = (
    newDomain: DomainPayload
): DomainAddStartAction => ({
    type: ActionTypes.DOMAIN_ADD_START,
    payload: {
        newDomain,
    },
    meta: {
        thunk: true,
    },
});
export const AddDomainFinish: ActionCreator<DomainAddFinishAction> = (
    domain: DomainDetail,
    meta: Record<string, unknown>
): DomainAddFinishAction => ({
    type: ActionTypes.DOMAIN_ADD_FINISH,
    payload: {
        domain,
    },
    meta,
});
export const AddDomainError: ActionCreator<DomainAddErrorAction> = (
    error: AddDomainErrorMessage,
    meta: Record<string, unknown>
): DomainAddErrorAction => ({
    type: ActionTypes.DOMAIN_ADD_ERROR,
    payload: error,
    meta,
    error: true,
});
export const LoadSpecificDomain: ActionCreator<DomainFetchSpecificStartAction> = (
    domainName: string
): DomainFetchSpecificStartAction => ({
    type: ActionTypes.DOMAIN_FETCH_SINGLE,
    payload: {
        domainName,
    },
});
export const LoadSpecificDomainSuccess: ActionCreator<DomainFetchSpecificSuccessAction> = (
    specificDomain: DomainDetail
): DomainFetchSpecificSuccessAction => ({
    type: ActionTypes.DOMAIN_FETCH_SINGLE_SUCCESS,
    payload: {
        specificDomain,
    },
});
export const VerifySpecificDomain: ActionCreator<DomainVerifySpecificStartAction> = (
    domainName: string
): DomainVerifySpecificStartAction => ({
    type: ActionTypes.DOMAIN_VERIFY_START,
    payload: {
        domainName,
    },
    meta: {
        thunk: true,
    },
});
export const VerifySpecificDomainSuccess: ActionCreator<DomainVerifySpecificSuccessAction> = (
    specificDomain: DomainDetail,
    meta: Record<string, unknown>
): DomainVerifySpecificSuccessAction => ({
    type: ActionTypes.DOMAIN_VERIFY_SUCCESS,
    payload: {
        domain: specificDomain,
    },
    meta,
});
export const VerifySpecificDomainError: ActionCreator<DomainVerifySpecificErrorAction> = (
    message: string,
    meta: Record<string, unknown>
): DomainVerifySpecificErrorAction => ({
    type: ActionTypes.DOMAIN_VERIFY_ERROR,
    payload: {
        message,
    },
    meta,
    error: true,
});
export const DeleteSpecificDomain: ActionCreator<DomainDeleteSpecificStartAction> = (
    domainName: string
): DomainDeleteSpecificStartAction => ({
    type: ActionTypes.DOMAIN_DELETE_START,
    payload: {
        domainName,
    },
});
export const DeleteSpecificDomainSuccess: ActionCreator<
    DomainDeleteSpecificSuccessAction
> = (): DomainDeleteSpecificSuccessAction => ({
    type: ActionTypes.DOMAIN_DELETE_SUCCESS,
});
export const DomainSetDefaultSender: ActionCreator<DomainSetDefaultAction> = (
    email: string
): DomainSetDefaultAction => ({
    type: ActionTypes.DOMAIN_SET_DEFAULT,
    payload: {
        email,
    },
    meta: {
        thunk: true,
    },
});
export const DomainSetDefaultSenderSuccess: ActionCreator<DomainSetDefaultSuccessAction> = (
    meta: Record<string, unknown>
): DomainSetDefaultSuccessAction => ({
    type: ActionTypes.DOMAIN_SET_DEFAULT_SUCCESS,
    meta,
});

export const DomainSetDefaultSenderError: ActionCreator<DomainSetDefaultErrorAction> = (
    meta: Record<string, unknown>
): DomainSetDefaultErrorAction => ({
    type: ActionTypes.DOMAIN_SET_DEFAULT_ERROR,
    meta,
});

export const UpdateDomainStart: ActionCreator<DomainUpdateStartAction> = (
    domainName: string,
    updatedOption: DomainDetail
): DomainUpdateStartAction => ({
    type: ActionTypes.DOMAIN_UPDATE_START,
    payload: {
        domainName,
        updatedOption,
    },
    meta: {
        thunk: true,
    },
});
export const UpdateDomainSuccess: ActionCreator<DomainUpdateSuccessAction> = (
    domains: DomainDetail[],
    meta: Record<string, unknown>
): DomainUpdateSuccessAction => ({
    type: ActionTypes.DOMAIN_UPDATE_SUCCESS,
    payload: {
        domains,
    },
    meta,
});
export const UpdateDomainError: ActionCreator<DomainUpdateErrorAction> = (
    message: string,
    meta: Record<string, unknown>
): DomainUpdateErrorAction => ({
    type: ActionTypes.DOMAIN_UPDATE_ERROR,
    payload: {
        message,
    },
    meta,
    error: true,
});
export const ClearSingleDomain: ActionCreator<ClearSingleDomainAction> = (): ClearSingleDomainAction => ({
    type: ActionTypes.DOMAIN_CLEAR_SINGLE_DOMAIN,
});

export const getDomainsStore = (state: ApplicationState): DomainState => state.domain;
